<template>
  <div class="main-app">
    <Sidebar v-if="this.$route.meta && this.$route.meta.requiresAuth" />
    <router-view
      :key="routerKey"
      class="main-content-wrapper"
      :style="{
        marginLeft: this.$route.meta && this.$route.meta.requiresAuth && !isSidebarCollapsed
          ? '210px'
          : this.$route.meta && this.$route.meta.requiresAuth && isSidebarCollapsed ? '50px'
            : ''
      }"
    />
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import {mapGetters} from 'vuex';

export default {
  name: 'App',
  components: {
    Sidebar,
  },
  computed: {
    ...mapGetters('appState', {
      isSidebarCollapsed: 'getSidebarState'
    }),
    routerKey() {
      let isNoForceReload = false;
      if (this.$route.meta.noForceReload) {
        isNoForceReload = true;
      }
      if (this.$route.params.forceReload) {
        isNoForceReload = false;
      }
      return isNoForceReload ? '' : this.$route.fullPath;
    }
  }
};
</script>

<style>

body {
  font-family: 'Inter', sans-serif;
  overflow-x: auto;
}

.main-app {
  display: flex;
}

.main-content-wrapper {
  width: 100%;
  position: relative;
  transition: all 0.3s ease-in-out;
}


</style>
